<!-- eslint-disable max-len -->
<template>
  <div class="row form-page-detail-body-container container-app-search">
    <div class="table-column">
      <v-client-table
        :data="dataColumn"
        :columns="columns"
        :options="table_options"
        class="jTable">
        <div
          slot="beforeFilter"
          class="custom-search">
          <b-form inline>
            <b-button
              v-if="showBtnAlterTable && form_data.type !== 'thirdparty'"
              class="btn grey btn-import-form"
              @click="openModalColumn">
              <i class="fa fa-plus fa-lg"/> Add
            </b-button>
          </b-form>
        </div>

        <div
          slot="is_primary_key"
          slot-scope="props">
          <j-toggle
            v-if="props.row.type === 'text'"
            v-model="props.row.is_primary_key"
            :disabled="!showBtnAlterTable || ((!!form_data.primary_key && props.row.name !== form_data.primary_key) || findRecord)"
            :class="{ 'disabled-primary' : !showBtnAlterTable || ((!!form_data.primary_key && props.row.name !== form_data.primary_key) || findRecord) }"
            @input="setPrimary($event, props)"/>
        </div>

        <div
          slot="is_use_regex"
          slot-scope="props">
          <span
            v-if="props.row.is_use_regex"
            class="text-true">TRUE</span>
          <span
            v-else
            class="text-false">FALSE</span>
        </div>

        <div
          slot="is_use_validation"
          slot-scope="props">
          <span
            v-if="props.row.is_use_validation"
            class="text-true">TRUE</span>
          <span
            v-else
            class="text-false">FALSE</span>
        </div>

        <div
          slot="initial_value"
          slot-scope="props">
          {{ props.row.initial_value || '-' }}
        </div>

        <div
          v-show="props.row.name !== 'created_at' &&
            props.row.name !== 'updated_at' &&
            props.row.name !== 'flow_status' &&
            props.row.name !== 'updated_by' &&
          props.row.name !== 'created_by'"
          slot="action"
          slot-scope="props">
          <img
            v-if="showBtnAlterTable && form_data.type !== 'thirdparty'"
            :src="require('@/assets/icon/query/edit.svg')"
            class="cursor-pointer m__r--5"
            width="13"
            @click="openDetail(props)">
          <img
            v-if="showBtnAlterTable && form_data.type !== 'thirdparty'"
            :src="require('@/assets/icon/query/delete.svg')"
            class="cursor-pointer"
            width="13"
            @click="deleteItem(props)">
        </div>
      </v-client-table>
    </div>

    <b-modal
      ref="appAddColumnModal"
      class="mod-form modal-add-column-data"
      centered
      no-close-on-esc
      no-close-on-backdrop>
      <div class="label-create-form-data">{{ isDetail ? 'UPDATE' : 'CREATE' }} COLUMN</div>
      <b-form-group :class="{'error-input' : $v.column_data.name.$error}">
        <label> Name </label>
        <j-input
          v-model="$v.column_data.name.$model"
          :error-required="$v.column_data.name.$error"
          :max-length="255"
          :disabled="isDetail && findRecord"
          placeholder="Name"/>
      </b-form-group>
      <b-form-group :class="{'error-input' : $v.column_data.type.$error}">
        <label> Type </label>
        <j-single-select
          v-model="$v.column_data.type.$model"
          :error-required="$v.column_data.type.$error"
          :options="typeOptions"
          :disabled="isDetail && findRecord"
          placeholder="Type"/>
      </b-form-group>
      <b-form-group :class="{'error-input' : $v.column_data.initial_value.$error}">
        <label> Default </label>
        <j-input
          v-model="$v.column_data.initial_value.$model"
          :error-required="$v.column_data.initial_value.$error"
          :max-length="255"
          placeholder="Default"/>
      </b-form-group>
      <b-row>
        <b-col md="3">
          <b-form-group :class="{'error-input' : $v.column_data.is_use_regex.$error}">
            <label> Regex </label>
            <j-toggle
              v-model="$v.column_data.is_use_regex.$model"/>
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group :class="{'error-input' : $v.column_data.is_use_validation.$error}">
            <label> Validation </label>
            <j-toggle
              v-model="$v.column_data.is_use_validation.$model"/>
          </b-form-group>
        </b-col>
      </b-row>
      <div v-show="column_data.is_use_validation">
        <label> Script </label>
        <j-monaco-editor
          v-if="openEditor"
          ref="scriptEditor"
          :value="column_data.validation_script"
          height="200px"
        />
        <b-form-group :class="{'error-input' : $v.column_data.validation_container_variable.$error}">
          <label> Container Variable </label>
          <j-input
            v-model="$v.column_data.validation_container_variable.$model"
            :error-required="$v.column_data.validation_container_variable.$error"
            :max-length="255"
            placeholder="Container Variable"/>
        </b-form-group>
        <b-form-group :class="{'error-input' : $v.column_data.validation_container_message.$error}">
          <label> Container Message </label>
          <j-input
            v-model="$v.column_data.validation_container_message.$model"
            :error-required="$v.column_data.validation_container_message.$error"
            :max-length="255"
            placeholder="Container Variable"/>
        </b-form-group>
      </div>
      <br>
      <div v-if="column_data.type === 'custom_class'">
        <v-client-table
          :data="dataColumnGroup"
          :columns="columns"
          :options="table_options"
          class="jTable">
          <div
            slot="beforeFilter"
            class="custom-search">
            <b-form inline>
              <b-button
                id="columnGroupAdd"
                class="btn grey btn-import-form m__r--5"
                @click="isDetailGroup = false">
                <i class="fa fa-plus fa-lg"/> Add
              </b-button>
            </b-form>
          </div>

          <div
            slot="is_primary_key"
            slot-scope="props">
            <span
              v-if="props.row.is_primary_key"
              class="text-true">TRUE</span>
            <span
              v-else
              class="text-false">FALSE</span>
          </div>

          <div
            slot="is_use_regex"
            slot-scope="props">
            <span
              v-if="props.row.is_use_regex"
              class="text-true">TRUE</span>
            <span
              v-else
              class="text-false">FALSE</span>
          </div>

          <div
            slot="action"
            slot-scope="props">
            <img
              :src="require('@/assets/icon/query/edit.svg')"
              class="cursor-pointer m__r--5"
              width="13"
              @click="openDetailGroup(props)">
            <img
              :src="require('@/assets/icon/query/delete.svg')"
              class="cursor-pointer"
              width="13"
              @click="deleteItemGroup(props)">
          </div>
        </v-client-table>
        <b-popover
          ref="popoverColumnGroup"
          :show.sync="popoverColumnGroupShow"
          target="columnGroupAdd"
          triggers="click"
          placement="right">
          <div class="label-create-form-data">{{ isDetailGroup ? 'UPDATE' : 'CREATE' }} COLUMN GROUP</div>
          <b-form-group :class="{'error-input' : $v.column_data_group.name.$error}">
            <label> Name </label>
            <j-input
              v-model="$v.column_data_group.name.$model"
              :error-required="$v.column_data_group.name.$error"
              :max-length="255"
              placeholder="Name"/>
          </b-form-group>
          <b-form-group :class="{'error-input' : $v.column_data_group.type.$error}">
            <label> Type </label>
            <j-single-select
              v-model="$v.column_data_group.type.$model"
              :error-required="$v.column_data_group.type.$error"
              :options="typeOptionsGroup"
              placeholder="Type"/>
          </b-form-group>
          <b-form-group :class="{'error-input' : $v.column_data_group.initial_value.$error}">
            <label> Default </label>
            <j-input
              v-model="$v.column_data_group.initial_value.$model"
              :error-required="$v.column_data_group.initial_value.$error"
              :max-length="255"
              placeholder="Default"/>
          </b-form-group>
          <br>
          <b-row>
            <b-col>
              <div class="float-to-right">
                <b-button
                  class="btn gray m__r--5"
                  @click="closeCreateColumnGroup">
                  Close
                </b-button>
                <b-button
                  class="btn blue"
                  @click="createColumnDataGroup">
                  Save
                </b-button>
              </div>
            </b-col>
          </b-row>
        </b-popover>
      </div>
      <br>
      <b-row>
        <b-col>
          <div class="float-to-right">
            <b-button
              class="btn gray m__r--5"
              @click="closeCreateColumn">
              Close
            </b-button>
            <b-button
              class="btn blue"
              @click="createColumnData">
              Save
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable import/no-extraneous-dependencies, no-nested-ternary, max-len, no-unused-vars, no-console */
import { required } from 'vuelidate/lib/validators';
import { mapState, mapActions } from 'vuex';
import jwtDecode from 'jwt-decode';
import jMonacoEditor from '@/components/monaco-editor/jMonacoEditor';

export default {
  // eslint-disable-next-line
  name: 'jFormColumn',
  components: {
    jMonacoEditor,
  },
  data() {
    return {
      dataColumn: [],
      dataColumnGroup: [],
      columns: ['name', 'type', 'is_primary_key', 'is_use_regex', 'is_use_validation', 'initial_value', 'action'],
      table_options: {
        headings: {
          name: 'FIELD',
          type: 'TYPE',
          is_primary_key: 'PRIMARY KEY',
          is_use_regex: 'REGEX',
          is_use_validation: 'VALIDATION',
          initial_value: 'DEFAULT',
          action: '',
        },
        sortIcon: { base: 'fa', up: 'fa-chevron-up', down: 'fa-chevron-down', is: 'fa-sort' },
        sortable: [],
        filterable: true,
        perPage: 100,
      },
      darkMode: false,
      openEditor: false,
      column_data: {
        name: '',
        type: null,
        initial_value: '',
        is_primary_key: false,
        is_use_regex: false,
        is_use_validation: false,
        validation_script: '',
        validation_container_variable: '',
        validation_container_message: '',
      },
      column_data_group: {
        name: '',
        type: null,
        initial_value: '',
      },
      typeOptions: [
        {
          id: 'text',
          text: 'Text',
        },
        {
          id: 'number',
          text: 'Number',
        },
        {
          id: '[]text',
          text: 'Array Of Text',
        },
        {
          id: '[]number',
          text: 'Array Of Number',
        },
        {
          id: 'boolean',
          text: 'Boolean',
        },
        {
          id: 'timestamp',
          text: 'Timestamp',
        },
        {
          id: 'person',
          text: 'Person',
        },
        {
          id: 'object',
          text: 'Object',
        },
        {
          id: 'maps',
          text: 'Maps',
        },
        {
          id: 'timer',
          text: 'Timer',
        },
        {
          id: '[]attachment',
          text: 'Array Of Attachment',
        },
        {
          id: '[]object',
          text: 'Array Of Object',
        },
        {
          id: 'tags',
          text: 'Tags',
        },
        {
          id: '[]tags',
          text: 'Array Of Tags',
        },
        {
          id: 'custom_class',
          text: 'Custom Class',
        },
      ],
      typeOptionsGroup: [
        {
          id: 'text',
          text: 'Text',
        },
        {
          id: 'number',
          text: 'Number',
        },
        {
          id: '[]text',
          text: 'Array Of Text',
        },
        {
          id: '[]number',
          text: 'Array Of Number',
        },
        {
          id: 'boolean',
          text: 'Boolean',
        },
        {
          id: 'timestamp',
          text: 'Timestamp',
        },
        {
          id: 'person',
          text: 'Person',
        },
        {
          id: 'object',
          text: 'Object',
        },
        {
          id: 'maps',
          text: 'Maps',
        },
        {
          id: 'timer',
          text: 'Timer',
        },
        {
          id: '[]attachment',
          text: 'Array Of Attachment',
        },
        {
          id: '[]object',
          text: 'Array Of Object',
        },
        {
          id: 'tags',
          text: 'Tags',
        },
        {
          id: '[]tags',
          text: 'Array Of Tags',
        },
      ],
      isDetail: false,
      onLoadDetail: false,
      indexData: 0,
      session: jwtDecode(JSON.parse(localStorage.getItem('Token')).value),
      popoverColumnGroupShow: false,
      isDetailGroup: false,
      indexDataGroup: 0,
      dataColumnEdit: null,
      findRecord: false,
    };
  },
  computed: {
    ...mapState('jStoreForm', ['form_id', 'form_data', 'privilege_by_me']),

    isAdmin() {
      const role = localStorage.getItem('userRole');
      return Number(role) === 1;
    },

    showBtnAlterTable() {
      return this.isAdmin || (this.privilege_by_me.includes('alter_table') && !this.privilege_by_me.includes('view_only'));
    },
  },
  watch: {
    // eslint-disable-next-line
    'column_data.name': function (val){
      const regexSymbol = /[^\w\s]/g;
      setTimeout(() => {
        this.column_data.name =
          val.toLowerCase()
            .replace(regexSymbol, '')
            .replace(' ', '_');
      }, 1);
    },

    // eslint-disable-next-line
    'column_data_group.name': function (val){
      const regexSymbol = /[^\w\s]/g;
      setTimeout(() => {
        this.column_data_group.name =
          val.toLowerCase()
            .replace(regexSymbol, '')
            .replace(' ', '_');
      }, 1);
    },

    // eslint-disable-next-line
    'column_data.is_use_validation': function (val){
      if (val && !this.onLoadDetail) {
        this.openEditor = true;
      }
    },

    form_data(val) {
      if (val.columns) {
        const columnData = Object.values(val.columns);
        this.dataColumn = columnData.map((e) => {
          e.is_primary_key = e.name === val.primary_key;
          return e;
        });
      }
    },
  },
  created() {
    this.getDetail();
  },
  methods: {
    ...mapActions('jStoreForm', ['updateForm', 'findForm', 'actionSetFormData', 'actionSetForm', 'actionSetNameForm', 'getCountDataRecord',
      'updateTable', 'removePrimaryKey', 'setPrimaryKey', 'findListTableByGroup']),
    ...mapActions('jStoreNotificationScreen', ['toggleInfo', 'toggleProblem']),

    getDetail() {
      if (this.form_data) {
        const reqTable = {
          tablegroup_id: this.$route.params.id,
          search: this.form_data.id,
        };
        this.findListTableByGroup(reqTable).then((res) => {
          if (res.data && res.data.length > 0) {
            const dataForm = res.data.find(f => f.id === this.form_data.id);
            this.actionSetFormData(dataForm);
          }
        });

        const reqData = {
          form_data_id: this.form_data.id,
        };
        this.getCountDataRecord(reqData).then((response) => {
          this.findRecord = response.data.count > 0;
        });
      }
    },

    openModalColumn() {
      this.isDetail = false;
      this.dataColumnGroup = [];
      this.$refs.appAddColumnModal.show();
    },

    closeCreateColumn() {
      this.column_data.name = '';
      this.column_data.type = null;
      this.column_data.initial_value = '';
      this.column_data.is_use_regex = false;
      this.column_data.is_primary_key = false;
      this.column_data.is_use_validation = false;
      this.column_data.validation_script = '';
      this.column_data.validation_container_variable = '';
      this.column_data.validation_container_message = '';
      this.$refs.appAddColumnModal.hide();
      this.openEditor = false;
      this.dataColumnEdit = null;
      setTimeout(() => {
        this.$v.column_data.$reset();
      }, 500);
    },

    createColumnData() {
      this.$v.column_data.$touch();
      if (!this.$v.column_data.$invalid) {
        if (this.column_data.name !== 'id' && this.column_data_group.name !== 'person'
        && this.column_data_group.name !== 'object' && this.column_data_group.name !== 'maps'
        && this.column_data_group.name !== 'attachment' && this.column_data_group.name !== 'timer'
        && this.column_data_group.name !== 'tags') {
          if (this.column_data.is_primary_key) {
            this.dataColumn.forEach((e) => {
              e.is_primary_key = false;
            });
          }
          const data = {
            name: this.column_data.name,
            initial_value: this.column_data.initial_value,
            type: this.column_data.type === 'custom_class' ? `[]${this.column_data.name}` : this.column_data.type,
            formula: '',
            is_use_regex: this.column_data.is_use_regex,
            is_primary_key: this.column_data.type === 'text' ? this.column_data.is_primary_key : false,
            is_use_validation: this.column_data.is_use_validation,
            validation_script: this.openEditor ? this.$refs.scriptEditor.getData() : '',
            validation_container_variable: this.column_data.validation_container_variable,
            validation_container_message: this.column_data.validation_container_message,
            group: this.dataColumnGroup,
          };

          if (this.isDetail) {
            this.$set(this.dataColumn, this.indexData, data);
          } else {
            this.dataColumn.push(data);
          }

          this.submitForm(data, this.isDetail ? 'update' : 'add');
        } else {
          this.toggleProblem('Name must be not id, person, object, maps, attachment, timer, and tags');
        }
      }
    },

    closeCreateColumnGroup() {
      this.column_data_group.name = '';
      this.column_data_group.type = null;
      this.column_data_group.initial_value = '';
      this.popoverColumnGroupShow = false;
      setTimeout(() => {
        this.$v.column_data_group.$reset();
      }, 500);
    },

    createColumnDataGroup() {
      this.$v.column_data_group.$touch();
      if (!this.$v.column_data_group.$invalid) {
        if (this.column_data_group.name !== 'id') {
          const data = {
            name: this.column_data_group.name,
            initial_value: this.column_data_group.initial_value,
            type: this.column_data_group.type,
            formula: '',
            is_use_regex: false,
            is_primary_key: false,
          };

          if (this.isDetailGroup) {
            this.$set(this.dataColumnGroup, this.indexDataGroup, data);
          } else {
            this.dataColumnGroup.push(data);
          }

          this.closeCreateColumnGroup();
        } else {
          this.toggleProblem('Name must be not id');
        }
      }
    },

    switchForm(data, id, name) {
      this.actionSetFormData(data);
      this.actionSetForm(id);
      this.actionSetNameForm(name);
    },

    submitForm(data, action) {
      const param = this.getParamsFormData(data);
      const session = this.session;
      const dataold = this.dataColumnEdit;

      this.updateTable({ param, session, data, action, dataold }).then((response) => {
        if (!response.error) {
          if (action === 'update' && this.dataColumnEdit.is_primary_key && this.dataColumnEdit.name !== param.name) {
            this.setPrimary(false, { row: { name: this.dataColumnEdit.name } });
          }
          if (action === 'delete') {
            const cekIsPrimary = this.form_data.columns[data.name] && this.form_data.columns[data.name].is_primary_key;
            if (cekIsPrimary) this.setPrimary(false, { row: { name: data.name } });
          }
          this.closeCreateColumn();
          this.switchForm(response.data, response.data.id, response.data.name);
        } else if (!response.error && response.error_session) {
          this.toggleInfo(response.message);
        } else {
          this.toggleProblem(response.message);
          if (this.form_data.columns) {
            const columnData = Object.values(this.form_data.columns);
            this.dataColumn = columnData.map((e) => {
              e.is_primary_key = e.name === this.form_data.primary_key;
              return e;
            });
          }
        }
      });
    },

    getParamsFormData(data) {
      const params = this._.cloneDeep(this.form_data);

      const dataPrimaryKey = this.dataColumn.find(e => e.is_primary_key);
      params.primary_key = dataPrimaryKey ? dataPrimaryKey.name : '';

      const dataClass = {
        person: {
          company_user_id: {
            formula: '',
            initial_value: '',
            is_primary_key: false,
            is_use_regex: false,
            name: 'company_user_id',
            type: 'number',
          },
          name: {
            formula: '',
            initial_value: '',
            is_primary_key: false,
            is_use_regex: true,
            name: 'name',
            type: 'text',
          },
          email: {
            formula: '',
            initial_value: '',
            is_primary_key: false,
            is_use_regex: true,
            name: 'email',
            type: 'text',
          },
          photo: {
            formula: '',
            initial_value: '',
            is_primary_key: false,
            is_use_regex: false,
            name: 'photo',
            type: 'text',
          },
        },
        object: {
          id: {
            formula: '',
            initial_value: '',
            is_primary_key: false,
            is_use_regex: false,
            name: 'id',
            type: 'text',
          },
          name: {
            formula: '',
            initial_value: '',
            is_primary_key: false,
            is_use_regex: true,
            name: 'name',
            type: 'text',
          },
        },
        maps: {
          latitude: {
            formula: '',
            initial_value: '',
            is_primary_key: false,
            is_use_regex: false,
            name: 'latitude',
            type: 'number',
          },
          longitude: {
            formula: '',
            initial_value: '',
            is_primary_key: false,
            is_use_regex: false,
            name: 'longitude',
            type: 'number',
          },
          address: {
            formula: '',
            initial_value: '',
            is_primary_key: false,
            is_use_regex: false,
            name: 'address',
            type: 'text',
          },
        },
        attachment: {
          name: {
            formula: '',
            initial_value: '',
            is_primary_key: false,
            is_use_regex: true,
            name: 'name',
            type: 'text',
          },
          url: {
            formula: '',
            initial_value: '',
            is_primary_key: false,
            is_use_regex: true,
            name: 'url',
            type: 'text',
          },
        },
        log: {
          start_time: {
            formula: '',
            initial_value: '',
            is_primary_key: false,
            is_use_regex: false,
            name: 'start_time',
            type: 'timestamp',
          },
          end_time: {
            formula: '',
            initial_value: '',
            is_primary_key: false,
            is_use_regex: false,
            name: 'end_time',
            type: 'timestamp',
          },
          duration: {
            formula: '',
            initial_value: '',
            is_primary_key: false,
            is_use_regex: false,
            name: 'duration',
            type: 'number',
          },
        },
        timer: {
          log: {
            formula: '',
            initial_value: '',
            is_primary_key: false,
            is_use_regex: false,
            name: 'log',
            type: '[]log',
          },
          state: {
            formula: '',
            initial_value: '',
            is_primary_key: false,
            is_use_regex: false,
            name: 'state',
            type: 'text',
          },
          duration: {
            formula: '',
            initial_value: '',
            is_primary_key: false,
            is_use_regex: false,
            name: 'duration',
            type: 'number',
          },
        },
        tags: {
          name: {
            formula: '',
            initial_value: '',
            is_primary_key: false,
            is_use_regex: true,
            name: 'name',
            type: 'text',
          },
          background: {
            formula: '',
            initial_value: '',
            is_primary_key: false,
            is_use_regex: false,
            name: 'background',
            type: 'text',
          },
          font_color: {
            formula: '',
            initial_value: '',
            is_primary_key: false,
            is_use_regex: false,
            name: 'font_color',
            type: 'text',
          },
        },
      };
      const dataColumns = {};

      this.dataColumn.forEach((e) => {
        if (this.typeOptions.filter(f => f.id === e.type).length === 0) {
          if (!this.form_data.class[e.name] || e.name === data.name) {
            dataClass[e.name] = {};
            this.dataColumnGroup.forEach((g) => {
              dataClass[e.name][g.name] = g;
            });
          } else {
            dataClass[e.name] = this.form_data.class[e.name];
          }
        }
        dataColumns[e.name] = e;
      });

      params.class = dataClass;
      // params.columns = dataColumns;
      delete params.columns;
      return params;
    },

    openDetail(data) {
      this.dataColumnEdit = data.row;
      this.dataColumnGroup = [];
      this.onLoadDetail = true;
      this.isDetail = true;
      this.indexData = data.index - 1;
      this.column_data.name = data.row.name;
      this.column_data.type = this.typeOptions.filter(f => f.id === data.row.type).length === 0 ? 'custom_class' : data.row.type;
      this.column_data.initial_value = data.row.initial_value;
      this.column_data.is_primary_key = data.row.is_primary_key;
      this.column_data.is_use_regex = data.row.is_use_regex;
      this.column_data.is_use_validation = data.row.is_use_validation;
      this.column_data.validation_script = data.row.validation_script;
      this.column_data.validation_container_variable = data.row.validation_container_variable;
      this.column_data.validation_container_message = data.row.validation_container_message;

      if (this.typeOptions.filter(f => f.id === data.row.type).length === 0) {
        const dataGroup = Object.values(this.form_data.class[data.row.name]);
        this.dataColumnGroup = dataGroup;
      }
      this.$refs.appAddColumnModal.show();
      setTimeout(() => {
        this.onLoadDetail = false;
      }, 100);
      setTimeout(() => {
        if (data.row.is_use_validation) {
          this.openEditor = true;
        }
      }, 300);
    },

    deleteItem(data) {
      if (this.findRecord) {
        this.toggleInfo("Can't delete column, because column already has records");
      } else {
        this.$swal({
          title: 'Are you sure to delete this column ?',
          text: '',
          showCancelButton: true,
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes',
        }).then(async (result) => {
          if (result.value) {
            const index = data.index - 1;
            this.dataColumn.splice(index, 1);
            const param = {
              formdata_id: this.form_data.id,
              name: data.row.name,
            };
            this.submitForm(param, 'delete');
          }
        });
      }
    },

    openDetailGroup(data) {
      this.isDetailGroup = true;
      this.indexDataGroup = data.index - 1;
      this.column_data_group.name = data.row.name;
      this.column_data_group.type = data.row.type;
      this.column_data_group.initial_value = data.row.initial_value;
      this.popoverColumnGroupShow = true;
    },

    deleteItemGroup(data) {
      const index = data.index - 1;
      this.dataColumnGroup.splice(index, 1);
    },

    setPrimary(val, data) {
      const param = {
        formdata_id: this.form_data.id,
        name: data.row.name,
      };
      const action = val ? 'setPrimaryKey' : 'removePrimaryKey';
      this[action](param).then(() => {
        this.getDetail();
      });
    },
  },
  validations() {
    return {
      column_data: {
        name: { required },
        type: { required },
        initial_value: { },
        is_use_regex: { },
        is_primary_key: { },
        is_use_validation: { },
        validation_script: { },
        validation_container_variable: { },
        validation_container_message: { },
      },
      column_data_group: {
        name: { required },
        type: { required },
        initial_value: { },
      },
    };
  },
};
</script>

<style lang="scss" scoped>
  .form-page-detail-body-container {
    // background-color: #ffffff;
    overflow: auto;
    margin: 1px;
    // height: 100%;
  }

  .table-column .jTable {
    width: 95%;
    margin-left: 15px;
  }

  .modal-add-column-data .modal-dialog {
    max-width: 500px !important;
  }

  .text-true {
    color: #61BC50;
    font-weight: bold;
    background: #F0F8E5;
    border-radius: 10px;
    padding: 2px 10px;
  }

  .text-false {
    color: #FF5A5A;
    font-weight: bold;
    background: #FFEDED;
    border-radius: 10px;
    padding: 2px 10px;
  }

  .disabled-primary {
    opacity: 0.5;
  }

  @media only screen and (max-height: 855px) {
    .table-column {
      // max-height: 550px;
      width: 100%;
    }
  }
  @media only screen and (min-height: 856px) {
    .table-column {
      // max-height: 650px;
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/data-manager/jFormColumn.vue